import _ from 'lodash'
import StatusSuccessPrefixBlock from './Success'
import StatusFailedPrefixBlock from './Failed'

const StatusPrefixBlock = props => {
  const {
    proposalType,
    listing,
    batchResult: {
      successProposalMap: successMap,
      failedProposalMap: failedMap
    } = {},
    isOverviewPage
  } = props
  const listingId = _.get(listing, 'id')
  const successProposal = _.get(successMap, listingId, {})
  const isUpdateSuccess = !_.isEmpty(successProposal)
  if (isUpdateSuccess) {
    // 更新成功區塊
    return (
      <StatusSuccessPrefixBlock
        proposalType={proposalType}
        listing={listing}
        successProposal={successProposal}
        isOverviewPage={isOverviewPage}
      />
    )
  }

  const failedProposal = _.get(failedMap, listingId, {})
  const isUpdateFailed = !_.isEmpty(failedProposal)
  if (isUpdateFailed) {
    // 更新失敗區塊
    return (
      <StatusFailedPrefixBlock
        listingId={listingId}
        failedProposal={failedProposal}
      />
    )
  }

  return null
}

export default StatusPrefixBlock
